import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CustomerAddress } from '../customer.interface';
import { AddressService } from './address.service';

const service = new AddressService();

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface AddressState {}

const AddressStore: Module<AddressState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async createAddress(context, payload: { customerId: number; address: CustomerAddress }) {
         const response = await service.postAddress(payload.customerId, payload.address);
         return response.data;
      },
      async putAddress(context, { customerId, addressId, address }: { customerId: number; addressId: number; address: CustomerAddress }) {
         const response = await service.putAddress(customerId, addressId, address);
         return response.data;
      },
      async postAddress(context, { customerId, address }: { customerId: number; address: CustomerAddress }) {
         const response = await service.postAddress(customerId, address);
         return response.data;
      },
      async call(context, { customerId, addressId, hitId }: { customerId: number; addressId: number; hitId?: number }) {
         const response = await service.call(customerId, addressId, hitId);
         return response.data;
      },
      async inviteToVideoRoom(
         context,
         { customerId, videocallRoomId, addressId }: { customerId: number; videocallRoomId: number; addressId: number },
      ) {
         const response = await service.inviteToVideoRoom(customerId, videocallRoomId, addressId);
         return response.data;
      },
   },
};

export default AddressStore;
